
//引入各个模块
import './module/index'


// loading
Vue.component("accelerate-loading",
    resolve => require(["../components/AccelerateLoading.vue"], resolve)
);

// footer
Vue.component("pub-footer",
    resolve => require(["../components/footer/index.vue"], resolve)
);


Vue.component(
    'Ad',
    resolve => require(["../components/Ad.vue"], resolve)
);


//登陆弹窗
Vue.component(
    'login',
    resolve => require(["../components/Login.vue"], resolve)
);


//iphone活动
Vue.component(
    'action-rank',
    resolve => require(["../components/ActionRank.vue"], resolve)
);

//修改手机号
// Vue.component(
//     'change-phone',
//     resolve => require(["../components/ChangePhone.vue"], resolve)
// );


// 通用视频播放器
Vue.component(
    'video-player',
    resolve => require(["../components/videoPlayer.vue"], resolve)
);


// 公共广告组件
Vue.component(
    'pub-ad',
    resolve => require(["../components/pubAd.vue"], resolve)
);
// 左侧公共广告组件
Vue.component(
    'pub-ad-left',
    resolve => require(["../components/pubAdLeft.vue"], resolve)
);
// 右侧公共广告组件
Vue.component(
    'pub-ad-right',
    resolve => require(["../components/pubAdRight.vue"], resolve)
);


//浏览器插件
Vue.component(
    'browser-plugin',
    resolve => require(["../components/solutions/browserPlugin.vue"], resolve)
);
//浏览器插件
Vue.component(
    'browser-plugin-tutorial',
    resolve => require(["../components/solutions/browserPluginTutorial.vue"], resolve)
);


// 付费去广告
Vue.component(
    'adfree-pay',
    resolve => require(["../components/adfree/pay"], resolve)
);

Vue.component(
    'adfree-success',
    resolve => require(["../components/adfree/success"], resolve)
);
Vue.component(
    'adfree-term',
    resolve => require(["../components/adfree/adfreeTerm"], resolve)
);


//首页顶部公告
Vue.component(
    'index-top-notice',
    resolve => require(["../components/indexTopNotice"], resolve)
);

//承诺书
Vue.component(
    'enterprise-promise',
    resolve => require(["../components/enterprisePromise"], resolve)
);


// 首页行业洞察
Vue.component(
    'insight-com',
    resolve => require(["../components/Insight"], resolve)
);

// 404页面
Vue.component(
    'cannot-find',
    resolve => require(["../components/cannotFind"], resolve)
);


//自助排障
Vue.component(
    'debug',
    resolve => require(["../components/Jiasu/debug"], resolve)
);

// 南京移动测速结束后弹窗表单
Vue.component(
    'test-end-form',
    resolve => require(["../components/testEnd/testEndForm"], resolve)
);


// 边走边侧
Vue.component(
    'video-collection',
    resolve => require(["../components/activity/video-collection"], resolve)
);


// 首页头部
Vue.component(
    "index-header",
    resolve => require(["../components/homePage/topHeader/index"], resolve)
)


// 3a游戏加速器页面
Vue.component(
    "three-a-game",
    resolve => require(["../components/gameSpeedUp/threeAGame/index"], resolve)
)

// 网速课堂入口
Vue.component(
    "konw-ledge-link",
    resolve => require(["../components/homePage/knowLink/index"], resolve)
)

//5G 设备Equipment 新增的echarts图
Vue.component(
    "ranks-5g",
    resolve => require(["../components/5g/ranks"], resolve)
)

//滁州联通落地页
Vue.component(
    "chu-zhou-serve",
    resolve => require(["../components/broadbandService/ChuZhouServe"], resolve)
)

//新人好礼落地页
Vue.component(
    "new-people-collection",
    resolve => require(["../components/newPeople/newPeopleCollection"], resolve)
)

//新人好礼弹窗
Vue.component(
    "new-people-pop",
    resolve => require(["../components/newPeople/newPeoplePop"], resolve)
)

//宽带提速优惠券落地页
Vue.component(
    "renewal-coupon-collection",
    resolve => require(["../components/renewalCoupon/renewalCouponCollection"], resolve)
)

//新人好礼弹窗
Vue.component(
    "renewal-coupon-pop",
    resolve => require(["../components/renewalCoupon/renewalCouponPop"], resolve)
)

//宽带提速活动弹窗
Vue.component(
    "speedup-activity-pop",
    resolve => require(["../components/speedupActivity/speedupActivityPop"], resolve)
)

//首页知识课堂轮播
Vue.component(
    "network-knowledge-swiper",
    resolve => require(["../components/index/networkKnowledgeSwiper.vue"], resolve)
)

// 首页赞助商组件
Vue.component(
    "sponsor",
    resolve => require(["../components/index/sponsor.vue"], resolve)
)

// 首页赞助商组件
Vue.component(
    "footer-module",
    resolve => require(["../components/footerModule.vue"], resolve)
)


// 隐私政策
Vue.component(
    "privacy",
    resolve => require(["../components/agreement/privacy.vue"], resolve)
)

// 用户协议
Vue.component(
    "terms",
    resolve => require(["../components/agreement/terms.vue"], resolve)
)

// 网站联通性测试
Vue.component(
    "webNetworkConnect",
    resolve => require(["../components/index/webNetworkConnect.vue"], resolve)
)

// 网站联通性测试
Vue.component(
    "toBIntroduce",
    resolve => require(["../components/index/toBIntroduce.vue"], resolve)
)

// 首页的发现模块
Vue.component(
    "indexDiscoveries",
    resolve => require(["../components/index/indexDiscoveries.vue"], resolve)
)

// 首页排行榜
Vue.component(
    "indexRanks",
    resolve => require(["../components/index/indexRanks"], resolve)
)

Vue.component(
    "noDataOrError",
    resolve => require(["../components/myElement/noDataOrError.vue"], resolve)
)

// 发现模块
Vue.component(
    "discoveries",
    resolve => require(["../components/discoveries/discoveries.vue"], resolve)
)

// 合作广告模块
Vue.component(
    "ads-content",
    resolve => require(["../components/adCooperation/AdsContent.vue"], resolve)
)






// WEBPACK FOOTER //
// ./resources/js/signCom/index.js